<template>
  <section>
    <!-- Header -->
    <div class="row mb-2">
      <div class="col-md-2">
        <h5>Notes</h5>
      </div>
      <div class="col-md-10">
        <button class="btn btn-primary btn-sm" @click="addNote">Add</button>
      </div>
    </div>
    <!-- Listing -->
    <div class="custom-wrapper">
      <div class="custom-add"></div>
      <z-table
        :value="notes"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center">
            <a href="#" @click="editNote(props.row.id)">edit</a>
          </td>
          <td>{{ formatDate(props.row.created_at) }}</td>
          <td>{{ props.row.subject }}</td>
          <td>{{ formatNote(props.row.note) }}</td>
          <td>{{ props.row.createdby }}</td>
          <td><a href="#" @click="confirmRemoval(props.row.id)">remove</a></td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <note-dialog
      id="note-modal"
      :show="actionNote"
      @close="closeModal"
      @saved="savedNote"
      @show="showFile"
    />
    <confirm-delete
      :show="actionDelete"
      :confirmTitle="confirmTitle"
      :confirmAction="confirmAction"
      :confirmQuestion="confirmQuestion"
      @closing="closeModal"
      @proceed="performDeletion"
    />
    <image-dialog
      id="image-modal"
      :show="actionImage"
      @close="closeImageModal"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import NoteDialog from '@/Components/UserCardio/client/notes/note-dialog'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
import ImageDialog from '@/Components/Coaching/coaching-image-dialog'
export default {
  name: 'user-notes',
  components: {
    ZTable,
    NoteDialog,
    ConfirmDelete,
    ImageDialog,
  },
  data() {
    return {
      page: 1,
      actionNote: null,
      isLoading: false,
      showSpin: null,
      currentId: null,
      confirmTitle: 'Remove Note',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove this Note',
      actionDelete: null,
      actionImage: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.currentId = null
    await this.loadNotes()
  },
  computed: {
    ...mapGetters('usercardio', ['member']),
    ...mapGetters('users', ['notes']),
    ...mapGetters('users', ['profile']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'created_at', label: 'Date', sortable: false },
        { field: 'subject', label: 'Subject', sortable: false },
        { field: 'note', label: 'Note', sortable: false },
        { field: 'createdby_id', label: 'Created By', sortable: false },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('users', [
      'getNotes',
      'getNote',
      'resetNote',
      'setNoteData',
      'removeNote',
    ]),
    closeModal() {
      this.actionNote = null
      this.actionDelete = null
      this.actionImage = null
    },
    closeImageModal() {
      this.actionImage = null
    },
    formatNote(note) {
      let _note = note
      if (note.length > 80) {
        _note = note.substring(0, 80) + ' ...'
      }
      return _note
    },
    formatDate(date) {
      return moment(new Date(date)).format('MM/DD/YYYY')
    },
    async loadNotes() {
      if (this.member) {
        await this.getNotes(this.member.id)
      }
    },
    async addNote() {
      this.resetNote()
      this.setNoteData({
        name: 'user_id',
        value: this.member.id,
      })
      this.actionNote = {
        isAdd: true,
        id: this.member.id,
      }
    },
    editNote(id) {
      this.resetNote()
      this.getNote(id)
      this.actionNote = {
        isAdd: false,
        id: id,
      }
    },
    async savedNote() {
      this.closeModal()
      await this.loadNotes()
    },
    confirmRemoval(id) {
      this.currentId = id
      this.actionDelete = true
    },
    async performDeletion() {
      await this.removeNote(this.currentId)
      this.actionDelete = null
      await this.loadNotes()
    },
    showFile(file) {
      this.actionImage = null
      console.log('Showing File', file)
      if (file.name.indexOf('.') >= 0) {
        let elements = file.name.split('.')
        let showImage = true
        if (elements.length > 0) {
          let ext = elements[elements.length - 1].toLowerCase()
          if (ext === 'pdf' || ext === 'doc' || ext === 'xls') {
            showImage = false
          }
        }
        if (showImage) {
          this.actionImage = file
        } else {
          window.open(file.url, '_blank')
        }
      }
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.column-header {
  height: 2em;
  line-height: 2em;
  position: relative;
}
.cursor {
  cursor: pointer;
}
.sort-base {
  color: #ddd;
}
.row-highlight {
  cursor: pointer;
}
.table-row-center {
  text-align: center;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
.custom-lines {
  position: relative;
  text-align: center;
  margin: 0 auto;
  color: #0d6efd;
  cursor: grab;
}
</style>
